import { useRooms } from '@services/common'
import { useTranslation } from 'react-i18next'

import { Label } from '@/components/ui/label'
import { MultiCombobox } from '@/components/ui/multi-combobox'

interface Props {
  value?: string[]
  onChange: (value: string[]) => void
  disabled?: boolean
}

export function RoomSelect({ value = [], onChange, disabled }: Props) {
  const { t } = useTranslation('application')
  const rooms = useRooms()

  const options = (rooms.data ?? [])
    .filter((room) => room.id)
    .map((room) => ({ value: room.id!, label: room.name ?? '' }))

  return (
    <div>
      <Label className="mb-1.5 block">{t('form.sections.housing.rooms')}</Label>
      <MultiCombobox
        value={value}
        onChange={onChange}
        options={options}
        disabled={disabled}
        placeholder={t('form.common.selectRooms')}
      />
    </div>
  )
}
